import styled from 'styled-components/macro';
import { ReactComponent as OfficialCharts } from 'icons/official-charts-button-icon.svg';

export const TabsWrapper = styled('section')`
  margin: 0 auto;
  background-color: ${({ theme }): string => theme.White};
  padding: ${({ theme }): string => theme.spacing.large};

  @media screen and (min-width: 60em) {
    padding: ${({ theme }): string => theme.spacing.large};
  }

  @media screen and (min-width: 80em) {
    padding: ${({ theme }): string => theme.spacing.xlarge};
  }
`;

export const DSPWrap = styled('div')<any>`
  margin-bottom: -1em;

  div:first-child > button:first-of-type,
  div:first-child > button:last-of-type {
    background-color: ${({ theme }): string => theme.White};
  }
`;

export const DSPChartToolbarIcon = styled('span')`
  margin: ${({ theme }): string => `0 ${theme.spacing.large} 0 1em`};
`;

export const OfficialChartIcon = styled(OfficialCharts)`
  g {
    stroke: ${({ theme }): string => theme.NightBlue};

    path {
      fill: ${({ theme }): string => theme.NightBlue};
    }
  }
`;
